import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';
import type { ProductionState } from '@/hooks/useProduction';

/** Which shot the crew is on right now, and how far through the board. */
export default function ShotProgressCard({ shotProgress }: { shotProgress: ProductionState['shotProgress'] }) {
  const { t } = useTranslation('production');
  if (!shotProgress) return null;

  return (
    <div className="flex items-center gap-3 text-sm">
      <Badge variant="outline" className="font-mono text-[10px]">
        {shotProgress.shot_id}
      </Badge>
      <span className="text-muted-foreground">{t(`shot.${shotProgress.step}`, { defaultValue: shotProgress.step })}</span>
      {shotProgress.model && <span className="font-mono text-xs text-faint">{shotProgress.model}</span>}
      <span className="ml-auto font-mono text-xs text-faint">
        {shotProgress.current}/{shotProgress.total_shots}
      </span>
    </div>
  );
}
